import { useState } from 'react';
import Button from 'components/Button';
import { newsroomError, setAlertNoindex } from 'api/newsroom';
import { news_alerts } from 'lang/en.json';
import styles from 'styles/modules/newsAlert/Detail.module.scss';
import { writesAlerts } from 'utils/subscriptionAccess';

const AdminButtons = ({
    status,
    handleEditArticle,
    handleCloseArticle,
    handleUpdateArticle,
    loading,
    edit,
    timeValid,
    dateValid,
    setActive,
    isAdmin,
    isContributingEditor,
    isFTEditor,
    plan,
    alertId,
    noindex,
    onNoindexChange,
}) => {
    const [noindexSaving, setNoindexSaving] = useState(false);
    const [noindexError, setNoindexError] = useState(null);
    const isContributingEditorOnly =
        (isContributingEditor || writesAlerts(plan?.type)) &&
        !isAdmin &&
        !isFTEditor;

    const toggleNoindex = async () => {
        setNoindexSaving(true);
        setNoindexError(null);
        try {
            const saved = await setAlertNoindex(alertId, !noindex);
            onNoindexChange(saved.noindex);
        } catch (err) {
            setNoindexError(newsroomError(err, 'Could not change it.'));
        } finally {
            setNoindexSaving(false);
        }
    };

    return (
        <div className={styles.adminButtons}>
            {/* Only show close button for admins and journalists, not contributing editors */}
            {status === 'active' && !isContributingEditorOnly && (
                <Button
                    loading={loading}
                    title={news_alerts.close_button}
                    onClick={handleCloseArticle}
                />
            )}

            {/* Show edit button for all (admins, journalists, contributing editors) */}
            <Button
                theme={'secondary'}
                title={edit ? 'Close Edit' : 'Edit NewsAlert'}
                onClick={handleEditArticle}
            />

            {/* Show update button for all when editing */}
            {edit && (
                <Button
                    title={'Update NewsAlert'}
                    theme={'success'}
                    loading={edit && loading}
                    onClick={handleUpdateArticle}
                    disabled={status === 'active' && (!timeValid || !dateValid)}
                />
            )}

            {/* Only show remove button for admins, not contributing editors */}
            {isAdmin && (
                <Button
                    theme={'danger'}
                    title={news_alerts.remove_button}
                    onClick={() => setActive(true)}
                />
            )}

            {isAdmin && alertId && (
                <Button
                    theme={'secondary'}
                    title={noindex ? 'Index in Google' : "Don't index"}
                    loading={noindexSaving}
                    onClick={toggleNoindex}
                />
            )}
            {isAdmin && noindex && (
                <span className={styles.noindexNote}>
                    Not indexed: this page is out of Google and the sitemaps.
                </span>
            )}
            {noindexError && (
                <span className={styles.noindexNote} role="alert">
                    {noindexError}
                </span>
            )}
        </div>
    );
};

export default AdminButtons;
